export const MANUAL_COPLIANCE_ID_SET = 'MANUAL_COPLIANCE_ID_SET';
export const MANUAL_COMPLIANCE_REDIRECT_SET = 'MANUAL_COMPLIANCE_REDIRECT_SET';
export const MANUAL_COMPLIANCE_SEARCH_SET = 'MANUAL_COMPLIANCE_SEARCH_SET';